import React, {FunctionComponent} from 'react';
import {Button, ButtonClass} from '@treez-ui/core/buttons';
import {SelectInput} from '@treez-ui/core/forms';
import {PriceTierMethod} from '@treez/commons/sharedTypings/priceTier';
import SearchBar from '~/modules/forms/SearchBar';
import {PriceManagementSearchParams} from '~/lib/sharedInterfaces';

export interface PriceTierOptions {
    onAdd: () => void;
    searchParams: PriceManagementSearchParams;
    onClearFilter: (field: string) => void;
    onFilter: (field: string, value: any) => void;
}

enum SelectMethodOptions {
    Weight = 'Weight',
    BulkWeight = 'Bulk Weight',
    UnitBased = 'Unit Based',
}

enum SelectActiveOptions {
    Active = 'Active',
    Inactive = 'Inactive',
}

export const PriceTierOptions: FunctionComponent<PriceTierOptions> = (props: PriceTierOptions) => {
    const {onAdd, onClearFilter, onFilter, searchParams} = props;

    const {label, method = null, isActive = null} = searchParams;

    const onSelectActiveChanged = (value: string) => {
        onFilter('isActive', value === 'Active');
    };

    const onSelectMethodChanged = (value: string) => {
        switch (value) {
            case SelectMethodOptions.Weight:
                onFilter('method', PriceTierMethod.WEIGHT);
                break;
            case SelectMethodOptions.BulkWeight:
                onFilter('method', PriceTierMethod.BULK);
                break;
            case SelectMethodOptions.UnitBased:
                onFilter('method', PriceTierMethod.UNIT);
                break;
            default:
                break;
        }
    };

    const getTierMethodToDisplay = (method: PriceTierMethod | null) => {
        switch (method) {
            case PriceTierMethod.WEIGHT:
                return SelectMethodOptions.Weight;
            case PriceTierMethod.BULK:
                return SelectMethodOptions.BulkWeight;
            case PriceTierMethod.UNIT:
                return SelectMethodOptions.UnitBased;
            default:
                return undefined;
        }
    };

    const getTierStatusDisplay = (isActive: string | null) => {
        if (isActive === 'true') {
            return SelectActiveOptions.Active;
        }
        if (isActive === 'false') {
            return SelectActiveOptions.Inactive;
        }

        return undefined;
    };

    const mapStringEnumToStringArray = (enumObject: object) => {
        return Object.keys(enumObject).map((key) => enumObject[key]);
    };

    const setSearchTerm = (value: string) => {
        onFilter('label', value);
    };

    return (
        <div className="price-tier-options-container">
            <Button text="+ Add Pricing Tier" buttonClass={ButtonClass.PREFERRED} onClick={onAdd} />
            <div className="options-right">
                <div className="search-bar-container">
                    <SearchBar
                        debounceDuration={500}
                        searchTerm={label}
                        setSearchTerm={setSearchTerm}
                        placeholder="Filter by Label"
                    />
                </div>
                <div className="filter-options-container">
                    <SelectInput
                        label="Filter by method"
                        options={mapStringEnumToStringArray(SelectMethodOptions)}
                        onChange={onSelectMethodChanged}
                        onClear={() => onClearFilter('method')}
                        value={getTierMethodToDisplay(method as PriceTierMethod)}
                    />
                    <SelectInput
                        label="Filter by Status"
                        options={mapStringEnumToStringArray(SelectActiveOptions)}
                        onChange={onSelectActiveChanged}
                        onClear={() => onClearFilter('isActive')}
                        value={getTierStatusDisplay(isActive)}
                    />
                </div>
            </div>
        </div>
    );
};
